module.exports = __webpack_public_path__ + "img/circle-info-solid.184ffb57.svg";